import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {Button} from '../../atoms/Button/Button';
import {Text} from '../../atoms/Text/Text';
import {ContentHomeBottomFixedButtonProps} from './ContentHomeBottomFixedButtonProps.interface';

export function ContentHomeBottomFixedButton({
  isMobile,
  className,
  isStatic,
  onClickButton,
  title,
  price,
  discountPrice,
  discountRate,
  subTitle,
  episode,
  ...props
}: ContentHomeBottomFixedButtonProps) {
  return (
    <div
      className={twMerge(
        isMobile && 'fixed inset-x-0 bottom-0 z-60',
        className
      )}
    >
      <div
        className={twMerge(
          'box-content flex items-center p-safe',
          isStatic
            ? isMobile
              ? 'bg-static-point-yellow text-static-mono-black'
              : 'bg-static-point-yellow text-static-mono-90'
            : 'bg-theme-solid-100 text-theme-solid-0',
          isMobile ? 'h-60pxr rounded-t-16pxr' : 'h-56pxr rounded-8pxr'
        )}
        {...props}
      >
        <div className="flex h-full w-full">
          <Button
            className={twMerge(
              'flex grow flex-col items-center justify-center px-15pxr',
              isMobile && 'space-y-1pxr',
              'bg-transparent!'
            )}
            onClick={onClickButton}
          >
            <Text
              className={twMerge(
                isMobile ? 'font-medium1-bold' : 'font-small2-bold',
                !isStatic && 'text-theme-solid-0'
              )}
            >
              {title}
            </Text>
            {subTitle && (
              <div
                className={twMerge(
                  'flex items-center',
                  isMobile ? 'font-small2 opacity-50' : 'font-x-small1',
                  !isStatic && 'font-small1 text-theme-solid-0 opacity-100'
                )}
              >
                <Text className="line-clamp-1 text-ellipsis break-all">
                  {subTitle}
                  {episode && <>&nbsp;</>}
                </Text>
                {episode && (
                  <Text className="inline-flex shrink-0 grow">{episode}</Text>
                )}
              </div>
            )}
            {!subTitle && price && (!discountRate || !discountPrice) ? (
              <Text className="font-small1 text-theme-solid-0">
                {t('common_cash_amount', {
                  values: {value: formatWithCommas(price)},
                })}
              </Text>
            ) : undefined}
            {!subTitle && price && discountRate && discountPrice ? (
              <div className="space-x-4pxr">
                <Text className="font-small1 text-theme-solid-0 line-through opacity-70">
                  {formatWithCommas(price)}
                </Text>
                <Text className="font-small1 text-static-point-red">
                  {t('common_cash_amount', {
                    values: {value: formatWithCommas(discountPrice)},
                  })}
                </Text>
              </div>
            ) : undefined}
          </Button>
        </div>
      </div>
    </div>
  );
}
